<template>
  <div v-once class="empty-cart">
    <div class="products-header">
      <h2 class="my-bag"><span v-html="$t('title.your.shopping.cart')"></span></h2>
    </div>

    <div class="empty-cart-body">
      <svg class="new-bag">
        <use :href="`${svgPath}#new-bag`" />
      </svg>

      <div class="empty-cart-message">
        <span><span v-html="$t('label.bagempty')"></span></span>
      </div>

      <a
        :href="emptyCartCTA.url"
        class="begin-checkout-btn"
        role="button"
        aria-pressed="true"
      >
        <span class="text"> <span v-html="emptyCartCTA.text"></span></span>
      </a>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { mapGetters as vue3_mapGetters } from "@/store/helper/vuex";

export default {
  name: "EmptyCart",
  setup() {
    const { vueVariables } = vue3_mapGetters();
    return { vueVariables };
  },
  data() {
    return {
      bestSellersCategoryId: this.vueVariables.bestSellersCategoryId,
      emptyCartCTA: this.vueVariables.emptyCartCTAOptions[this.vueVariables.locale] || {},
    };
  },
  created() {
  },
  computed: {
    ...mapState(["svgPath", "actionURLs"])
  },
};
</script>

<style >
</style>
